export const HEADER_HEIGHT = '60px'
export const HEADER_WITH_SECONDARY_MENU_HEIGHT = '105px'
